module.exports = __webpack_public_path__ + "media/images/flags/SR-d53d00f02ab716170f69551dbdf67ff1.svg";